export default __webpack_public_path__ + "static/media/image_5.b9066d36.png";